import script from "./ProgressBarCardObject.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgressBarCardObject.vue?vue&type=script&setup=true&lang=js"

import "./ProgressBarCardObject.vue?vue&type=style&index=0&id=25ac12b5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\Code\\GK\\MulticaseWeb\\MulticaseWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25ac12b5"]])

export default __exports__